import {
  ABOUT_DETAIL_FETCH,
  ABOUT_DETAIL_SUCCESS,
  ABOUT_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const aboutDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case ABOUT_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case ABOUT_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case ABOUT_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/AboutDetail/reducer.js